export default __webpack_public_path__ + "static/media/more-brown.88b717f4.png";